import { Row, Col } from '@wyz/ui';
import { VehicleTypeListItem } from '~/connect/components';
import { useController, useFormContext } from 'react-hook-form';
import { ISettingTemplateForm } from '~/connect/types';
import { ITranslatedVehicleTypeGroup } from '~/common/types';

type Props = {
  coreVehicleTypeGroups: ITranslatedVehicleTypeGroup[];
};

export function VehicleTypeGroupField({ coreVehicleTypeGroups }: Props) {
  const methods = useFormContext<ISettingTemplateForm>();
  const { field } = useController({
    control: methods.control,
    name: 'vehicleTypeGroups',
  });

  return (
    <Row>
      {coreVehicleTypeGroups.map((coreVehicleTypeGroup) => {
        const isActivated = field.value.some(
          (formGroup) => formGroup.publicKey === coreVehicleTypeGroup.publicKey,
        );

        return (
          <Col
            key={coreVehicleTypeGroup.publicKey}
            className='my-2'
            xxl={2}
            md={3}
            xs={12}
          >
            <VehicleTypeListItem
              coreVehicleTypeGroup={coreVehicleTypeGroup}
              isActivated={isActivated}
              onToggle={() =>
                field.onChange(
                  isActivated
                    ? field.value.filter(
                        (formGroup) =>
                          formGroup.publicKey !==
                          coreVehicleTypeGroup.publicKey,
                      )
                    : [...field.value, coreVehicleTypeGroup],
                )
              }
            />
          </Col>
        );
      })}
    </Row>
  );
}
